export enum ShipmentTypes {
    GET_SHIPMENTS_BY_DATE_RANGE_LOADING = "GET_SHIPMENTS_BY_DATE_RANGE_LOADING",
    GET_SHIPMENTS_BY_DATE_RANGE_SUCCESS = "GET_SHIPMENTS_BY_DATE_RANGE_SUCCESS",
    GET_SHIPMENTS_BY_DATE_RANGE_FAILURE = "GET_SHIPMENTS_BY_DATE_RANGE_FAILURE",
    GET_SHIPMENTS_OVERVIEW_LOADING = "GET_SHIPMENTS_OVERVIEW_LOADING",
    GET_SHIPMENTS_OVERVIEW_SUCCESS = "GET_SHIPMENTS_OVERVIEW_SUCCESS",
    GET_SHIPMENTS_OVERVIEW_FAILURE = "GET_SHIPMENTS_OVERVIEW_FAILURE",
}
